import {
  type NavigateProps,
  // biome-ignore lint/style/noRestrictedImports: We're creating our wrapped Navigate version here
  Navigate as RouterNavigate,
  useLocation,
} from "react-router-dom";

export const Navigate = (props: NavigateProps) => {
  const location = useLocation();

  const locationHistoryStack = location.state?.locationHistoryStack || [];

  return (
    <RouterNavigate
      {...props}
      state={{
        ...props.state,
        locationHistoryStack: props.replace
          ? locationHistoryStack
          : [location, ...locationHistoryStack],
      }}
    />
  );
};
